<div class="bg-dark border-right p-3" id="sidebar">
    <h3 class="text-light">
      Gif-App
    </h3>
    <hr class="text-light"/>
    <div class="list-group list-reset">
      <a 
        href="#"
        class="list-group-item list-group-item-action"
        *ngFor="let elemento of historial"
        (click)="buscar(elemento)"
      >
        {{elemento | titlecase}}
      </a>
    </div>
</div>